import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { toast } from "react-toastify";
import { AddSubcompany, DeleteSubCompany, UpdateSubCompany } from './AddSubCompany';
import { BASE_URL } from '../../../config/axios';

const SubCompany = ({ subComapany, buffer, getSubcompany }) => {

    return (
        <>
            <div className='table-box scroll-container-table'
                style={{ height: "80vh" }}
            >

                <table className="table-css width-100vw">
                    <thead className="table-heading">
                        <tr className="custom-table-head-tr ">
                            <th className="table-heading-text text-left-sr">S.No.</th>
                            <th className="table-heading-text">Company Name</th>
                            <th className="table-heading-text text-center">Mobile Number</th>
                            <th className="table-heading-text text-center">GST Number</th>

                            <th className="table-heading-text text-center">Logo </th>



                            <th className="table-heading-text ">Address</th>

                            <th className="table-heading-text text-center" style={{ justifyContent: 'right', paddingRight: '40px' }}>Action </th>


                        </tr>
                    </thead>
                    <tbody style={{ height: "70vh" }}>
                        {buffer ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "center" }}>
                                    <div className="spinner-bgdatil"></div>
                                </td>
                            </tr>
                        ) : (
                            subComapany.map((i, index) => (
                                <tr key={index} className="custom-table-head-td">
                                    <td className="table-body text-left-sr">{index + 1}.</td>
                                    <td className="table-body">
                                        <div style={{ width: "200px", whiteSpace: "wrap" }}>{i.company_name}</div>
                                    </td>
                                    <td className="table-body text-center">{i.company_number}</td>
                                    <td className="table-body text-center">{i.company_gst}</td>
                                    <td className="table-body text-center">
                                        <img style={{ width: `80px` }} src={i.company_logo} alt="companyLogo" />
                                    </td>
                                    <td className="table-body">
                                        <div style={{ width: "200px", whiteSpace: "wrap" }}>{i.company_address}</div>
                                    </td>
                                    <td className="table-body text-right">
                                        <div className="flex-row justify-center text-center">
                                            <UpdateSubCompany i={i} getSubcompany={getSubcompany} />
                                            <DeleteSubCompany i={i} getSubcompany={getSubcompany} />
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>

                </table>


            </div>

        </>
    );
};

export default SubCompany;
